import { useState } from "react"
import Button from "components/Form/Button"
import InputNew from "components/Form/newAuthInput"
import { useLang } from "hooks/useLang"
import useLogin from "hooks/useLogin"
import PhoneInput from "components/atoms/PhoneInput/newAuthPhoneInput"
import VerificationComponent from "components/page_components/auth/User/Verification/verification"
import Link from "next/link"
import { useRouter } from "next/router"

interface IProps {
    onLoginSuccess?: (token: string) => void
    isRedirect?: boolean
    onSwitchToSignup?: () => void
    isModalView?: boolean
}

const NewAuthLoginForm = ({
    onLoginSuccess,
    isRedirect,
    onSwitchToSignup,
    isModalView = false,
}: IProps) => {
    const { t } = useLang()
    const {
        submit,
        handleInput,
        disableButton,
        form,
        inputType,
        inputValue,
        check,
        errorForm,
        isLoading,
        resetUserExist,
    } = useLogin({ isRedirect, onLoginSuccess })

    const [loginType, setLoginType] = useState("phone")
    const [isVerification, setIsVerification] = useState(false)

    const router = useRouter()
    const { redirect } = router.query
    const signupUrl = redirect
        ? `/user/signup?redirect=${redirect}`
        : "/user/signup"

    const onSubmit = (e: any) => {
        try {
            submit(e)
            setIsVerification(true)
        } catch (error) {
            // biome-ignore lint/complexity/noUselessCatch:
            throw error
        }
    }

    const toggleLoginType = (type: "phone" | "email") => {
        setLoginType(type)
    }

    const handleSignupInsteadClick = (
        e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement, MouseEvent>
    ) => {
        if (isModalView) {
            e.preventDefault()
            onSwitchToSignup?.()
        } else {
            resetUserExist()
        }
    }

    if (isVerification && check.isUserExist) {
        return (
            <VerificationComponent
                value={inputValue}
                type={inputType}
                callingCode={form.callingCode}
            // redirectPath={}
            // setShowOtpPage={setOTPLogin}
            />
        )
    }

    return (
        <div className="flex flex-col gap-8 ">
            <div className="w-full">
                <div className="w-full px-2 py-4">
                    <span className="text-[28px] font-bold text-[#000] dark:text-[#fff]">
                        {t("login")}
                    </span>
                </div>
                <div className="w-full flex flex-row bg-[#FFFFFF4D] justify-between rounded-full">
                    <div
                        onClick={() => toggleLoginType("phone")}
                        className={`cursor-pointer flex-1 rounded-full text-center py-2 ${loginType === "phone"
                            ? "dark:bg-[#fff] bg-[#80a2ff]"
                            : ""
                            }`}
                    >
                        <span
                            className={`${loginType === "phone" ? "dark:text-[#221953] text-white" : "dark:text-[#fff] text-[#000]"}`}
                        >
                            {t("phone")}
                        </span>
                    </div>
                    <div
                        onClick={() => toggleLoginType("email")}
                        className={`cursor-pointer flex-1 rounded-full text-center py-2  ${loginType === "email"
                            ? "dark:bg-[#fff] bg-[#80a2ff]"
                            : ""
                            }`}
                    >
                        <span
                            className={`${loginType === "email" ? "dark:text-[#221953] text-white" : "dark:text-[#fff] text-[#000]"}`}
                        >
                            {t("email")}
                        </span>
                    </div>
                </div>
                <div className="mt-4 px-3">
                    <span className="text-4 font-400 text-white">
                        {t(`enter${loginType}ToLogin`)}
                    </span>
                </div>
            </div>
            <form onSubmit={onSubmit} className="flex flex-col gap-4 md:gap-5">
                {loginType === "email" ? (
                    <InputNew
                        label={t("lb_email")}
                        inputID="email_login"
                        name="email"
                        type="email"
                        autoComplete="email"
                        onChange={(e) => handleInput("email", e.target.value)}
                        value={form.email}
                        error={errorForm?.email}
                        autoFocus
                        inputContainerClassName="h-[40px]"
                        placeholder={t("lb_email")}
                        reqStar
                    />
                ) : (


                    <>


                        <PhoneInput
                            callingCode={form.callingCode}
                            setCallingCode={(callingCode: string) =>
                                handleInput("callingCode", callingCode)
                            }
                            setPhone={(phone: string) =>
                                handleInput("phone", phone)
                            }
                            phone={form.phone}
                            error={errorForm?.phone}
                            autoFocus
                            required
                            inputContainerClassName="h-[40px]"
                            placeholder={t("phoneNumber")}
                        />
                    </>

                )}

                <div className="w-full bg-[#F0F0F033] h-[1px] mt-3"></div>

                <div className="flex justify-between items-center w-full flex-col gap-4">
                    {/* <div className="flex flex-col">
                        <p className="text-xs text-gray-600 dark:text-gray-200 md:text-sm">
                            {t("dont_have_account")}
                        </p>
                        <Link
                            onClick={handleSignupInsteadClick}
                            href={signupUrl}
                            passHref
                            className="text-[#0DB9A0] text-xs md:text-sm"
                        >
                            {t("btn_signup")}
                        </Link>
                    </div> */}

                    <Button
                        text={t("btn_Continue")}
                        loading={check.isLoading || isLoading}
                        disabled={disableButton()}
                        type="submit"
                        theme="modern"
                        className="p-2 bg-[#1DC2AB] w-full"
                    />

                    <Link
                        onClick={handleSignupInsteadClick}
                        href={signupUrl}
                        passHref
                        className=" w-full"
                    >
                        <Button
                            text={t("btn_signup")}
                            // loading={check.isLoading || isLoading}
                            // disabled={disableButton()}
                            onClick={handleSignupInsteadClick}
                            theme="modern"
                            className="p-2 bg-transparent border-[#1DC2AB] w-full"
                        />
                    </Link>

                </div>
            </form>
        </div>
    )
}

export default NewAuthLoginForm
